/* eslint-disable require-jsdoc */
import {getFetch} from './fetch/fetch';
import {getAjax} from './ajax/ajax';
import {useFetch} from '../config';

async function getHttp(url, auth) {
  return useFetch ? await getFetch(url, auth) : await getAjax(url, auth);
}
export default {
  get: getHttp,
};

// async function getFetch(args) {
//   let result;
//   await fetch(args)
//   // let result;
//       .then((response) =>{
//         result = response.json();
//         console.log(response);
//       })
//       .catch((error) => console.log(error));
//   // .then(data => data)
//   return result;
// }
